import { DEFAULT_TENANT_FINANCIAL_LINE, DEFAULT_TENANT_FINANCIAL_TYPE } from "@/constants";

interface ResolveFinancialProductDefaultsParams {
  isApiOwner: boolean;
  hasSessionId: boolean;
}

interface FinancialProductFields {
  financial_product_line_id: string | undefined;
  financial_product_type_id: string | undefined;
}

/**
 * Decide the financial product line/type a session should carry, based on
 * whether it is API-owned and whether it already exists.
 *
 *  - Non-API sessions always get the tenant defaults (Non-API / Tenant Catalog).
 *  - Brand-new API sessions start empty so the user selects the values.
 *  - Existing API sessions are left untouched (returns undefined) so a reload
 *    never wipes values the user already saved.
 *
 * @returns the fields to apply, or `undefined` when the session should be left as-is.
 */
export const resolveFinancialProductDefaults = ({
  isApiOwner,
  hasSessionId,
}: ResolveFinancialProductDefaultsParams): FinancialProductFields | undefined => {
  if (!isApiOwner) {
    return {
      financial_product_line_id: DEFAULT_TENANT_FINANCIAL_LINE.id,
      financial_product_type_id: DEFAULT_TENANT_FINANCIAL_TYPE.id,
    };
  }
  if (hasSessionId) {
    return undefined; // existing API session — preserve saved values
  }
  return { financial_product_line_id: undefined, financial_product_type_id: undefined };
};
